import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  MarginContainer,
  VBox,
  ButtonWithHover,
  Loader,
  NinePatchRect,
  VBoxHBox,
  CenterContainer,
} from "@liro_u/react-components";
import {
  RotateMove,
  ScaleMove,
  useOnMouseHover,
} from "@liro_u/react-animation-components";
import ProjectPreview from "./fragments/ProjectPreview";

import customRoutes from "../../utils/routes";
import { routes } from "@liro_u/cms-front";

import { usePageRatioContext } from "@liro_u/cms-front";

import { useVerifyAuth, useAuthContext } from "@liro_u/react-auth-components";
import AnimatedProjectPreview from "./fragments/AnimatedProjectPreview";

const FavProjectPreview = ({
  style,
  gameTitle,
  jamTitle,
  webTitle,
  noResultText,
  moreText,
}) => {
  const refGame = useRef(null);
  const refJam = useRef(null);
  const refWeb = useRef(null);

  const GameHover = useOnMouseHover(refGame);
  const JamHover = useOnMouseHover(refJam);
  const WebHover = useOnMouseHover(refWeb);

  const { user } = useAuthContext();
  const [projects, setProjects] = useState([]);
  const [projectType, setProjectType] = useState("GAME");
  const [isLoading, setIsLoading] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const { pageRatio } = usePageRatioContext();
  const { verifyAuth } = useVerifyAuth();
  const navigate = useNavigate();

  const associatedLink = {
    GAME: customRoutes.gameProject,
    JAM: customRoutes.jamProject,
    WEB: customRoutes.webProject,
    ALL: customRoutes.allProject,
  };

  const typeButtonStyle = {
    color: "var(--light-color)",
    width: pageRatio === "tel" ? "100%" : "33%",
    cursor: "pointer",
    borderBottom: "solid 3px",
    transition: "border-bottom-color 0.3s ease",
  };

  const projectPreviewStyle = {
    marginLeft: pageRatio === "tel" ? "-5vw" : 0,
    marginRight: pageRatio === "tel" ? "-5vw" : 0,
  };

  useEffect(() => {
    const fetchFromDataBase = async () => {
      setIsLoading(true);
      const headers = {};
      if (user) {
        headers.Authorization = `Baerer ${user.token}`;
      }
      const response = await fetch(
        process.env.REACT_APP_PROXY + "/api/project/fav/" + projectType,
        { headers }
      );

      const json = await response.json();

      if (response.ok) {
        setProjects(json);
      } else {
      }
      setIsLoading(false);
    };
    if (projectType) {
      fetchFromDataBase();
    }
  }, [projectType, user]);

  const createNewProject = async () => {
    setIsCreating(true);
    const response = await fetch(
      process.env.REACT_APP_PROXY + "/api/project/",
      {
        method: "POST",
        body: JSON.stringify({ type: projectType }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Baerer ${user.token}`,
        },
      }
    );

    const json = await response.json();

    if (response.ok) {
      navigate(routes.page + "/" + json._id);
    } else {
      verifyAuth(json);
    }
    setIsCreating(false);
  };

  const renderProjects = () => {
    let children = [];
    if (user) {
      children.push(
        <ProjectPreview
          key={-1}
          name={{
            fr: "Add " + projectType + " project",
            en: "Ajouter un " + projectType + " project",
          }}
          style={{ cursor: "pointer", ...projectPreviewStyle }}
          onClick={isCreating ? () => {} : createNewProject}
        />
      );
    }
    projects.forEach((project, index) => {
      children.push(
        <AnimatedProjectPreview
          project={project}
          index={index}
          style={projectPreviewStyle}
        />
      );
    });
    return children;
  };

  return (
    <div className="favProjectPreview" style={{ ...style }}>
      <NinePatchRect
        style={{ width: pageRatio === "tel" ? "95vw" : "70vw" }}
        centerStyle={{ overflow: "visible" }}
      >
        <MarginContainer margin={pageRatio === "tel" ? "10px" : "30px"}>
          <VBox
            style={{
              textAlign: "center",
            }}
            gap="30px"
          >
            <VBoxHBox
              style={{
                justifyContent: "space-around",
              }}
              vbox={pageRatio === "tel"}
            >
              <h1
                ref={refGame}
                style={{
                  ...typeButtonStyle,
                  borderBottomColor:
                    projectType === "GAME" || GameHover ? "#ffff" : "#fff0",
                }}
                onClick={(e) => setProjectType("GAME")}
              >
                {gameTitle}
              </h1>
              <h1
                ref={refJam}
                style={{
                  ...typeButtonStyle,
                  borderBottomColor:
                    projectType === "JAM" || JamHover ? "#ffff" : "#fff0",
                }}
                onClick={(e) => setProjectType("JAM")}
              >
                {jamTitle}
              </h1>
              <h1
                ref={refWeb}
                style={{
                  ...typeButtonStyle,
                  borderBottomColor:
                    projectType === "WEB" || WebHover ? "#ffff" : "#fff0",
                }}
                onClick={(e) => setProjectType("WEB")}
              >
                {webTitle}
              </h1>
            </VBoxHBox>
            <h1>{isLoading}</h1>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {(projects && projects.length > 0) || user ? (
                  <VBox gap="10px">{renderProjects()}</VBox>
                ) : (
                  <h1>{noResultText}</h1>
                )}
                <MarginContainer marginTop={"20px"}>
                  <CenterContainer>
                    <RotateMove time={0.5} rotateEnd="10deg" mode="onHover">
                      <ScaleMove time={0.5} scaleEnd="1.2" mode="onHover">
                        <Link to={associatedLink[projectType]}>
                          <ButtonWithHover
                            text={moreText}
                            fontSize={pageRatio === "tel" ? "20px" : undefined}
                          />
                        </Link>
                      </ScaleMove>
                    </RotateMove>
                  </CenterContainer>
                </MarginContainer>
              </>
            )}
          </VBox>
        </MarginContainer>
      </NinePatchRect>
    </div>
  );
};

export default FavProjectPreview;
